import React, {useEffect, useRef, useState} from "react";
import styles from "./ListWithRedactor.module.scss"
import Redactor from "../Redactor/Redactor";
import List from "../List/List";
type getTemplatesResponse = {
    message:template[]
}
export type template ={
    id: number
    renderedTemplate: string
    name: string
    pattern: string
    jsonExample: object
}
export type ListWithRedactorProps = {
    setAuthState:(value:boolean|null)=>void
    token:string
}
export default function ListWithRedactor(props:ListWithRedactorProps){
    const [id, setId] = useState<number>(0)
    const [templateName, setTemplateName] = useState<string>('')
    const [htmlCode, setHtmlCode] = useState<string>('')
    const [jsonCode, setJsonCode] = useState<string>('')
    const [renderedHtml, setRenderedHtml] = useState<string>('')
    const [templateList, setTemplateList]=useState<template[]>([])
    const demoRef = useRef<HTMLIFrameElement>(null);
    useEffect(() => {
        fetch(process.env.REACT_APP_BASE_URL+'/GetTemplates',{
            headers:{
                "Authorization":props.token
            }
        }).then((response)=>response.json()).then((result:getTemplatesResponse)=>{
            setTemplateList(result.message)
        }).catch((e)=>{
            console.log(e)
            setTemplateList([])
        })
    }, []);
    const deleteByName = (name:string)=>{
        fetch(process.env.REACT_APP_BASE_URL+'/DeleteTemplate/'+name,{
            method:'POST',
            headers:{
                "Authorization":props.token
            }
        }).then((response)=>{
            if(response.status===200){
                let newTemplateList = templateList.slice()
                console.log(newTemplateList.length)
                let index = newTemplateList.findIndex(item=>item.name===name)
                console.log(index)
                if(index>=0){
                    newTemplateList.splice(index,1)
                    console.log(newTemplateList.length)
                    setTemplateList(newTemplateList)
                }
            } else {
                if (response.status===403){
                    props.setAuthState(false)
                }
            }
        }).catch((e)=>{
            console.log(e)
        })
    }
    const showDemo = (html:string)=>{
        if(window!==null){
            let newWindow = window.open('','',`width=${window.outerWidth},height=${window.outerHeight}`);
            if(newWindow!==null){
                newWindow.document.write(html)
            }
        }
    }
    return (
        <div className={styles.ListWithRedactor}>
            <Redactor
                id={id}
                name={templateName}
                htmlCode={htmlCode}
                jsonCode={jsonCode}
                renderedHtml={renderedHtml}
                setRenderedHtml={setRenderedHtml}
                setId={setId}
                setTemplateName={setTemplateName}
                setHtmlCode={setHtmlCode}
                setJson={setJsonCode}
                setTemplateList={setTemplateList}
                templateList={templateList}
                setAuthState={props.setAuthState}
                token={props.token}
                showDemo={showDemo}
            />
            <List
                list={templateList}
                selectedId={id}
                setId={setId}
                setName={setTemplateName}
                setPattern={setHtmlCode}
                setJsonExample={setJsonCode}
                deleteByName={deleteByName}
                showDemo={showDemo}
            />
        </div>
    )
}